import { useEffect } from "react";
import {
    logout,
    selectIsEditingMode,
    selectUser,
    selectUserUpdatingStatus,
    setIsEditingMode,
    setIsSaving,
    setLogoutStatus,
    setUnauthorized,
    setUserUpdatingStatus,
} from "../userSlice";
import { useDispatch, useSelector } from "react-redux";
import JurInputs from "./JurInputs";
import IndividualInputs from "./IndividualInputs";
import { Button } from "@mui/material";
import RedSpinner from "../../../components/loaders/RedSpinner";
import { setPathToAuthentication, setPrevPath } from "../../path/pathSlice";
import { setAuthenticated } from "../../authentication/authSlice";
import { setRegistrated } from "../../registration/registrationSlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { pushAlert } from "../../alerts/alertSlice";
import GreenSpinner from "../../../components/loaders/GreenSpinner";

const Main = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    const navigate = useNavigate();

    const logoutStatus = useSelector((state) => state.user.statuses.logout);
    const updatingStatus = useSelector(selectUserUpdatingStatus);
    const isEditing = useSelector(selectIsEditingMode);
    const userUpdatingStatus = useSelector(selectUserUpdatingStatus);

    const handleEditButtonClick = () => {
        if (isEditing) {
            dispatch(setIsSaving(true));
            return;
        }
        dispatch(setIsEditingMode(!isEditing));
    };

    const handleLogoutButtonClick = () => {
        dispatch(logout());
    };

    useEffect(() => {
        if (logoutStatus === "fulfilled") {
            dispatch(
                setPrevPath({
                    prevpath: "/profile",
                })
            );
            dispatch(setLogoutStatus(null));
            dispatch(setUnauthorized(false));
            dispatch(setAuthenticated(false));
            dispatch(setRegistrated(false));
            dispatch(setPathToAuthentication());
        }
    }, [dispatch, logoutStatus]);

    //on Success updating
    useEffect(() => {
        if (updatingStatus === "fulfilled") {
            dispatch(setUserUpdatingStatus(null));
            navigate("/shipments");
            return;
        }
        if (updatingStatus === "rejected") {
            dispatch(setUserUpdatingStatus(null));
            dispatch(
                pushAlert({
                    message: t("something_went_wrong"),
                    type: "danger",
                    delay: 2000,
                })
            );
            dispatch(setIsEditingMode(true));
            return;
        }
    }, [dispatch, navigate, t, updatingStatus]);

    return (
        <>
            {user && user["user-type"] === "individual" && <IndividualInputs />}
            {user && user["user-type"] === "legal" && <JurInputs />}
          <div className="flex gap-2">
              <div className="text-right mt-4">
                  <Button
                      variant="contained"
                      sx={{
                          color: "white",
                          bgcolor: isEditing ? "#047857" : "#059669",
                          fontSize: "0.7rem",
                          ":hover": {
                              bgcolor: "#047857",
                          },
                      }}
                      onClick={handleEditButtonClick}
                  >
                      {userUpdatingStatus ? (
                          <GreenSpinner width={20} height={20} />
                      ) : isEditing ? (
                          t("user.save")
                      ) : (
                          t("user.edit")
                      )}
                  </Button>
              </div>
              <div className="text-right mt-4">
                  <Button
                      variant="contained"
                      sx={{
                          color: "white",
                          bgcolor: "#dc2626",
                          fontSize: "0.7rem",
                          ":hover": {
                              bgcolor: "#b91c1c",
                          },
                      }}
                      onClick={handleLogoutButtonClick}
                  >
                      <span>{t("user.logout")}</span>
                      {logoutStatus === "pending" && (
                          <span className="ml-3">
                              <RedSpinner width={15} height={15} />
                          </span>
                      )}
                  </Button>
              </div>
          </div>
        </>
    );
};

export default Main;
